import Tabs from '@components/V4/Tabs/Tabs';

import CapacityTab from './CapacityTab/CapacityTab';
import CoursesAndSubjectsTab from './CoursesAndSubjectsTab/CoursesAndSubjectsTab';
import EnrollmentsTab from './EnrollmentsTab/EnrollmentsTab';
import PartialEnrollmentsTab from './PartialEnrollmentsTab/PartialEnrollmentsTab';
import PaymentsTab from './PaymentsTab/PaymentsTab';
import QualityScoreTab from './QualityScoreTab/QualityScoreTab';
import ResumeTab from './ResumeTab/ResumeTab';
import SettingsTab from './SettingsTab/SettingsTab';

export type MentorTab =
  | 'active-enrollments'
  | 'ended-enrollments'
  | 'partial-enrollments'
  | 'courses-and-subjects'
  | 'capacity'
  | 'payments'
  | 'ai-scoring'
  | 'resume'
  | 'settings';

interface MentorTabsSectionProps {
  tab?: MentorTab;
}

const MentorTabsSection = (props: MentorTabsSectionProps) => {
  const { tab = 'active-enrollments' } = props;

  const tabs: { label: string; value: MentorTab }[] = [
    { label: 'Active Enrollments', value: 'active-enrollments' },
    { label: 'Ended Enrollments', value: 'ended-enrollments' },
    { label: 'Partial Enrollments', value: 'partial-enrollments' },
    { label: 'Courses & Subjects', value: 'courses-and-subjects' },
    { label: 'Capacity', value: 'capacity' },
    { label: 'Payments', value: 'payments' },
    { label: 'AI Scoring', value: 'ai-scoring' },
    { label: 'Resume', value: 'resume' },
    { label: 'Settings', value: 'settings' },
  ];

  const renderContent = (currentTab: MentorTab) => {
    switch (currentTab) {
      case 'active-enrollments':
        return <EnrollmentsTab areEnrollmentsActive />;
      case 'ended-enrollments':
        return <EnrollmentsTab />;
      case 'partial-enrollments':
        return <PartialEnrollmentsTab />;
      case 'courses-and-subjects':
        return <CoursesAndSubjectsTab />;
      case 'capacity':
        return <CapacityTab />;
      case 'payments':
        return <PaymentsTab />;
      case 'ai-scoring':
        return <QualityScoreTab />;
      case 'resume':
        return <ResumeTab />;
      case 'settings':
        return <SettingsTab />;
      default:
        return null;
    }
  };

  return (
    <div className="mt-6">
      <Tabs tabs={tabs} initialTab={tab} renderContent={renderContent} />
    </div>
  );
};

export default MentorTabsSection;
